import request from './request'
import * as http from '@/libs/http'

/**
 * ステーション一覧を取得する
 *
 * @param {String} orgcode 組織コード
 * @param {Object} params パラメータ
 * @returns {Response} レスポンスデータ
 */
export function getStations (orgcode, params = {}) {
  return request.get(`/org/${orgcode}/stations`, {
    params: {
      ...params,
      fields: [
        'stationID',
        'shopID',
        'profile',
        'meta'
      ]
    },
    validateStatus: (status) => [
      http.OK,
      http.NotFound
    ].includes(status)
  })
}
